<template>
	<el-dialog
		title="导入案件"
		:visible.sync="dialogVisible"
		width="700px"
		:before-close="handleClose"
	>
    <el-upload
        ref="uploadRef"
        action="#"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="handleImportFile"
        accept=".xls,.xlsx"
        class="upload-demo"
        drag
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        点击上传或拖拽文件到此处
      </div>
      <template #tip>
        <div class="el-upload__tip">
          支持 .xlsx, .xls 格式文件
        </div>
      </template>
    </el-upload>
    <div class="tip">
      导入说明：<br>
      1. 请下载模板文件，按照模板格式填写案件信息<br>
      2. 导入文件大小不能超过10MB<br>
      3. 建议每次导入不超过100条记录
    </div>
		<div class="import-result">
			<div class="result-content" v-html="resultData"></div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleClose">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import {importAccept} from "@/api/recognition";
export default {
	props: {
		isDialog: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		dialogVisible: {
			get() {
				return this.isDialog
			},
			set(val) {
				this.$emit('handleClose')
			}
		}
	},
  data(){
    return {
      resultData:''
    }
  },
	methods: {
    handleRefresh(){
      this.$emit("refresh")
    },
    // 导入文件
    handleImportFile(file) {
      const isExcel = file.raw.type === 'application/vnd.ms-excel' ||
          file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isLt10M = file.raw.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('只能上传 .xls 或 .xlsx 格式的文件！')
        return
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB！')
        return
      }

      const formData = new FormData()
      formData.append('file', file.raw)
      importAccept(formData).then(res => {
        if (res && res.code === 200) {
          this.resultData = res.data
          this.handleRefresh()
        } else {
          this.$message.error(res.msg || '导入失败')
        }
      }).catch(err => {
        console.error('导入出错', err)
        this.$message.error('导入失败')
      }).finally(() => {
      })
    },
		handleClose() {
      this.handleRefresh()
			this.$emit('handleClose')
		}
	}
}
</script>

<style lang="scss" scoped>
.import-result {
	.result-content {
		padding: 16px;
		background: #f5f7fa;
		border-radius: 4px;
		max-height: 300px;
		overflow-y: auto;
		line-height: 1.8;
		color: #606266;
	}
}
/deep/.el-upload {
  width: 100%;
  .el-upload-dragger {
    width: 100%;
  }
}
.tip{
  padding: 16px;
  border-radius: 4px;
  border: 1px dashed rgba(255, 62, 80, 1);
  background: rgba(254, 237, 238, 1);
  color: rgba(255, 62, 80, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 10%;
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
